import { render, staticRenderFns } from "./AuthorityView.vue?vue&type=template&id=6a89af46&scoped=true&"
import script from "./AuthorityView.vue?vue&type=script&lang=js&"
export * from "./AuthorityView.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityView.vue?vue&type=style&index=0&id=6a89af46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89af46",
  null
  
)

export default component.exports